import React, { useEffect, useState } from "react";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { api } from "../../api";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Paper } from "@material-ui/core";
//import storeIcon from "../../assets/images/store_service.png";
import SyncIcon from '@material-ui/icons/Sync';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    Padding: {
      padding: "1em",
    },
    serviceNameTypography: {
      color: "#051057",
      fontWeight: "bold",
      fontSize: "0.99rem",
      // padding: "0.5em",
      textAlign: "left",
    },
    statusTypography: {
      color: " #4527a0",
      fontWeight: "bold",
      fontSize: "0.814rem",
      // padding: "0.5em",
      textAlign: "left",
    },
  })
);
// type NotificationObjectType = {
//   ServiceName: string;
//   status: string;
//   Error: string;
// };

export const Notification = () => {
  const classes = useStyles();
  const [notificationArray, setNotificationArray] = useState<Array<Object>>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [permissionFlag, setPermissionFlag] = useState<boolean>(false);

  useEffect(() => {
    try {
      const interval = setInterval(async () => {
        const notificationResult = await api.get(`notification`);
        if (notificationResult.message === "You are not authorized for this action") {
          setPermissionFlag(true);
        } else {
          setIsLoading(false);
          setNotificationArray(notificationResult);
          setPermissionFlag(false);
        }
      }, 10000);
      return () => clearInterval(interval);
    } catch (e) {
      setPermissionFlag(true);
      // console.log("inside error message");
      setIsLoading(true);
    }
  },[permissionFlag]);
  return (
    <Grid
      container
      spacing={3}
      direction="row"
    >
      <Grid item xs={12} style={{ display: permissionFlag ? "none" : "" }}>
        {isLoading ? (
          <LinearProgress color="primary" />
        ) : (
          <Grid
            container
            spacing={3}
            direction="row"
            justify="center"
            alignItems="center"
          >
            {notificationArray &&
              notificationArray.map((notification: any) => (
                <Grid item xs={12}>
                  <Paper>
                    <Grid
                      container
                      direction="row"
                      justify="flex-start"
                      alignItems="center"
                    >
                      <Grid item xs={2} className={classes.Padding}>
                        {/* <img src={storeIcon} alt="storeIcon" /> */}
                        <SyncIcon  style={{
                          fontSize: "63px",
                          color: "#2a3e52"
                        }}/>
                      </Grid>
                      <Grid item xs={10} className={classes.Padding}>
                        {" "}
                        <Typography className={classes.serviceNameTypography}>
                          {notification.ServiceName}
                        </Typography>
                        <Typography className={classes.statusTypography}>
                           {notification.status} 
                        </Typography>
                        <Typography
                          style={{
                            color: "#4527a0",
                            fontWeight: "bold",
                            display:
                              notification.Error === "No Error" ? "none" : " ",
                            fontSize: "0.814rem",
                            // padding: "0.5em",
                            textAlign: "left",
                          }}
                        >
                          {/* Error : {notification.Error} */}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
              ))}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
